import React from 'react';
import WarehouseList from './components/WarehouseList';
import styled from "styled-components";


const HelpPageWrapper = styled.div`
  background-color: #f7f7f7;
  position: relative;
  padding: 50px 0 50px 0;
  min-height: 50vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  
  table.drag-drop tbody tr td:first-child {
    cursor: all-scroll;
  }

  @media (max-width: 989px) {
    padding-top: 70px;
  }
`;

const WarehouseShow = () => {
  let admin = localStorage.getItem("admin");
  if(!admin) {
    window.location.href = "/";
  }
  return (
    <HelpPageWrapper>
      <WarehouseList />
    </HelpPageWrapper>
  );
};

export default WarehouseShow;